import clsx from 'clsx'
import { campaignApi, CampaignsUI } from 'features/campaigns'
import { type Dispatch, type SetStateAction, useId } from 'react'
import {
	type CampaignKey,
	type SimplifiedCampaign,
	URLSearchParser
} from 'shared/search-adapters'
import { ListSelect } from 'shared/ui'

import css from './Filters.module.css'
import { useSomeDegenerateFetching } from './Locations'

CampaignsSelect.simplify = (
	campaigns: SimplifiedCampaign[]
): SimplifiedCampaign[] => campaigns.map(({ id, name }) => ({ id, name }))

CampaignsSelect.init = (
	params: URLSearchParams,
	key: CampaignKey
): SimplifiedCampaign[] => {
	const url = new URLSearchParams(params)
	return URLSearchParser.Campaigns(url, key)
}

export function CampaignsSelect({
	className,
	setter,
	value
}: {
	className?: string
	setter: Dispatch<SetStateAction<SimplifiedCampaign[]>>
	value: SimplifiedCampaign[]
}) {
	const [fetchCampaigns, queryOptions] = campaignApi.useLazyCampaignsPageQuery()

	const { isPlanned, ...props } = useSomeDegenerateFetching($searchQuery =>
		fetchCampaigns({
			$filter: `not (state eq 'Compose')`,
			$orderby: 'created desc',
			$searchQuery
		})
	)

	const id = useId()

	let showOptions = queryOptions.data?.documents ?? value
	if (queryOptions.isFetching || isPlanned) {
		showOptions = []
	}

	return (
		<div className={clsx(css.set, className)}>
			<label className={css.label} htmlFor={id}>
				Participated in Campaigns
			</label>
			<ListSelect
				formatOptionLabel={CampaignsUI.Option}
				getOptionLabel={c => c.name}
				getOptionValue={c => c.id}
				getTag={c => c.name}
				hideSelectedOptions
				inputId={id}
				isLoading={
					queryOptions.isFetching || queryOptions.isLoading || isPlanned
				}
				isMulti
				onChange={values => setter(Array.from(values))}
				{...props}
				options={showOptions}
				placeholder='Select campaigns'
				setter={setter}
				value={value}
			/>
		</div>
	)
}
